import React, {useEffect, useRef} from 'react';
import {Form,} from 'antd';
import type {ProFormInstance} from '@ant-design/pro-form';
import type {WdiModalAppProps} from '@/components/WdiControls';
import {FieldProps} from "@/components/WdiControls";
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ResponseStatus} from '@/utils/request';
import {WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {BOHQ} from "@/services/mdm/bohq";
import {Enum} from "@/enums/system";
import {LevelEnum} from "@/enums/level";

const MyActivityApplyPrev: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  useEffect(() => {
    (async () => {
      if (props.data) {
        formRef.current?.setFieldsValue({
          relatedFormId: props.data.relatedFormId,
          relationType: props.data.relationType
        });
      }

    })();
  }, []);

  return (
    <WdiModalForm
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose ? props.onClose() : null
        },
        okText: '下一步'
      }}
      {...HorzLayoutOpts}
      onFinish={async (values) => {
        const entity = {
          formTypeId: Enum.FormType.ACTIVITY_MKT_APPLICATION,
          pageGroupId: Enum.PageGroup.MKT_APPLICATION,
          pageTypeId: Enum.PageType.MKT_APPLICATION,
          bohqId: WdiSelectFormat.getvalue(values.bohqId),
          relatedFormId: values.relatedFormId,
          relationType: values.relationType
        };
        const response: any = {
          code: ResponseStatus.SUCCESS,
          message: '成功',
          data: entity,
        };
        if (props.onSave) {
          props.onSave(response);
        }
      }}
    >
      <Form.Item name="relatedFormId" label="relatedFormId" hidden={true}>
        <input hidden></input>
      </Form.Item>
      <Form.Item name="relationType" label="relationType" hidden={true}>
        <input hidden></input>
      </Form.Item>
      <Form.Item name="bohqId" label='预算归属' rules={[{required: true}]}>
        <WdiTreeSelect
          {...{
            placeholder: '请选择预算归属',
            labelInValue: true,
            //defaultExpandKeys: expandKeysProductReachEx,
            dataLoading: async (params) => {
              const response = await BOHQ.search(Object.assign({
                  isActive: true,
                  withPermissions: true,
                  existMoreRoot: true,
                  bohqLevels: [LevelEnum.BOHqLevel.BO1, LevelEnum.BOHqLevel.BO2].join(),
                },
                params));
              const {treeData, dict} = FieldProps.TreeSelect.formatTreeData(
                {
                  textField: 'bohqName',
                  valueField: 'bohqId',
                  id: 'bohqId',
                  pId: 'parentId',
                  level: 'bohqLevel',
                  disabledLevel: [0, 1],
                },
                response.data,
              );
              return {treeData, dict};
            },
          }}
        />
      </Form.Item>
    </WdiModalForm>
  );
};
export default MyActivityApplyPrev;
